import { createDownloadActions } from 'partner360/components/asyncContentWrapper/model'
import { PARTNER360_FIN_COCKPIT_NAMESPACE } from 'partner360/features/financialCockpit/constants'

export const {
  requestingStarted,
  downloadStarted,
  downloadProgress,
  downloadSucceeded,
  downloadFailed,
  processingStarted,
  downloadCancelled,
  resetDownload,
} = createDownloadActions(PARTNER360_FIN_COCKPIT_NAMESPACE)
